import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param labelId Number
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (labelId, organisationId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_LABEL, {
        organisationId: organisationId,
        labelId: labelId
    });
    var request = new Request({ method: Methods.DELETE, url: url, withCredentials: true });
    return request.execute();
});
